import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PaymentMethods } from './pre-order-details.model';
import {
  paymentMethodsBuilderUI,
  preOrderBuilderUI
} from './pre-order-details.mappers';

@Injectable({
  providedIn: 'root'
})
export class PreOrderDetailsService {
  baseUrl = environment.apiUrl;

  constructor(private _http: HttpClient) {}

  getPaymentMethods(): Observable<PaymentMethods> {
    return this._http
      .get(`${this.baseUrl}/payment-methods`)
      .pipe(map(paymentMethodsBuilderUI));
  }

  setPreOrder(propertyId, params) {
    return this._http
      .post(`${this.baseUrl}/properties/${propertyId}/pre-order`, params)
      .pipe(map(preOrderBuilderUI));
  }
}
